export default __webpack_public_path__ + "static/media/img2.3da50f67.webp";